var GradesInfo = {
    TBD: {
        shortText: 'TBD',
        fullText: 'TBD',
    },
    '-2': {
        shortText: 'TBD',
        fullText: 'TBD',
    },
    '-1': {
        shortText: 'PK',
        fullText: 'Pre-kindergarten',
    },
    '0': {
        shortText: 'K',
        fullText: 'Kindergarten',
    },
    '1': {
        shortText: 'G1',
        fullText: 'Grade 1',
    },
    '2': {
        shortText: 'G2',
        fullText: 'Grade 2',
    },
    '3': {
        shortText: 'G3',
        fullText: 'Grade 3',
    },
    '4': {
        shortText: 'G4',
        fullText: 'Grade 4',
    },
    '5': {
        shortText: 'G5',
        fullText: 'Grade 5',
    },
};
var Grade = /** @class */ (function () {
    // eslint-disable-next-line no-useless-constructor
    function Grade(gradeValue) {
        this.gradeValue = gradeValue;
    }
    Object.defineProperty(Grade.prototype, "value", {
        get: function () {
            return this.gradeValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Grade.prototype, "shortText", {
        get: function () {
            return GradesInfo[this.gradeValue].shortText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Grade.prototype, "fullText", {
        get: function () {
            return GradesInfo[this.gradeValue].fullText;
        },
        enumerable: false,
        configurable: true
    });
    return Grade;
}());
export { Grade };
